import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
function My() {
  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valuesetUserDeatils, setUserDeatils] = useState({});

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window !== "undefined") {
      setValue(localStorage.getItem("access_token"));
      setValuevendor(localStorage.getItem("access_token_vendor"));

      const userDetails = localStorage.getItem("access_user");

      setUserDeatils(JSON?.parse(userDetails));
    } else {
      setValue("");
      setValuevendor("");
      setUserDeatils({});
    }
  }, []);
  const deshboard = useSelector((state) =>
    state?.allapi?.deshboard ? state?.allapi?.deshboard : {}
  );
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );

  useEffect(() => {
    // dispatch(allapiAction.vendordeshBoradData({}));
    // dispatch(allapiAction.categoryWiseSale({}));
    dispatch(allapiAction.deshBoradDataUserData());
    dispatch(allapiAction.getprofile());

    return () => {};
  }, []);

  let pageUrl =
    "https://SVKgroup.com/referalsignup?ref=" +
    get_profile?.referId;


    function copy() {
    const el = document.createElement("input");
    el.value = pageUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // setCopied(true);
    toast.success("Your Referal link Copied!");

    // setstshareshow(false);
  }
  return (
    <div>
      <Header />
      <div classsName="my">
        <div class="container mt-5 pt-5 mb-5 pb-5">
          <div className="pro_tre" style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)" }}
          >
          <div class="profile-card text-center p-3">
            <img
              src="https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250"
              alt="User Image"
              class="rounded-circle"
              width="60"
            />
            <h5 class="mt-2 text-white">
              {get_profile?.fullName ? get_profile?.fullName : "******"}
            </h5>
            <p class="text-white">UID: {get_profile?.referId ? get_profile?.referId : "******"}</p>
            <p class="text-white"> { moment(get_profile?.createdAt).format(" DD/MM/YYYY ") ?  moment(get_profile?.createdAt).format(" DD/MM/YYYY ") : "******"}</p>
            <div class="d-inline-block  text-white p-2 rounded" style={{ backgroundImage: "linear-gradient(90deg, rgba(255, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 50%, rgba(255, 165, 0, 1) 100%)", color: "white", padding: "20px", textAlign: "center", borderRadius: "10px", fontSize: "18px" }}>Package: {deshboard?.totalInvestmentAmount} </div><br></br>
            <div class="d-inline-block bg-light p-2 rounded mt-2" style={{ backgroundImage: "linear-gradient(90deg, rgba(255, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 50%, rgba(57, 255, 20, 1) 100%)", color: "white", padding: "20px", textAlign: "center", borderRadius: "10px", fontSize: "18px" }}>
            Income:  {get_profile?.earningbalance ? get_profile?.earningbalance?.toFixed(4) : 0}{" "}
            
            </div>
            <br /><br/>
            <div class="d-inline-block bg-light p-2 rounded">
              <button onClick={copy} className="btn-stakevt">
                Copy Referal Link
              </button>
            </div>
            

          </div>
          </div>
          <div class="wallet-card mt-2">
            <h5 class="fw-bold " style={{ color: "rgb(203 20 105)" }}>
            <i class="fa-solid fa-wallet">Wallet Balance</i>
            </h5>
            <h3>
              <img class="main-1-img-position" src="img/t logo.png" alt="" />{" "}
              {get_profile?.balance ? get_profile?.balance : 0}
            </h3>
            <div >
            <table class="table table-responsive"  >
              <thead>
                <tr >
                  <th style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}></th>
                  {/* <th>Daily Income</th> */}
                  <th style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>Total Income</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white"  }}> Profit</td>
                  {/* <td>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0.0
                  </td> */}
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    {deshboard?.aarohiIncome
                      ? deshboard?.aarohiIncome?.toFixed(2)
                      : 0}
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>Level Income</td>
                  {/* <td>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0.0
                  </td> */}
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    {deshboard?.lavelIncomes
                      ? deshboard?.lavelIncomes?.toFixed(2)
                      : 0}
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>Direct Income</td>
                  {/* <td>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0.0
                  </td> */}
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    {deshboard?.directincome
                      ? deshboard?.directincome?.toFixed(2)
                      : 0}
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>Roylity Income</td>
                  {/* <td>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0.0
                  </td> */}
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    {deshboard?.matchingIncomes
                      ? deshboard?.matchingIncomes?.toFixed(2)
                      : 0}
                  </td>
                </tr>
                <tr >
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>Direct Team</td>
                  {/* <td>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0.0
                  </td> */}
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    {deshboard?.DirectTeam ? deshboard?.DirectTeam : 0}
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>All Teams</td>
                  {/* <td>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0.0
                  </td> */}
                  <td style={{ backgroundImage: "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",color:"white" }}>
                    <img
                      class="main-1-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    {deshboard?.allTeam ? deshboard?.allTeam : 0}
                  </td>
                </tr>
              </tbody>
            </table>
            
            </div>
          </div>

          <div class="team-card ss" style={{ background: "radial-gradient(circle, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)" }}>
            <h6 class="fw-bold bg-dark text-warning p-2">
              <i class="bi bi-people icon"></i>My Income
            </h6>
            <hr />
            <div class="row text-center">
              <div class="col-3" onClick={() => navigate("/trading-income")}>
                <i class="bi bi-people"></i>
                <p>
                  {" "}
                  {deshboard?.aarohiIncome
                    ? deshboard?.aarohiIncome?.toFixed(2)
                    : 0}
                </p>
                <p class="text-center text-white"> Profit</p>
              </div>
              <div class="col-3" onClick={() => navigate("/level-income")}>
                <i class="bi bi-award"></i>
                <p>
                  {" "}
                  {deshboard?.lavelIncomes
                    ? deshboard?.lavelIncomes?.toFixed(2)
                    : 0}
                </p>
                <p class="text-center text-white">Level Income</p>
              </div>
              <div class="col-3" onClick={() => navigate("/roylity-income")}>
                <i class="bi bi-clipboard"></i>
                <p>
                  {" "}
                  {deshboard?.matchingIncomes
                    ? deshboard?.matchingIncomes?.toFixed(2)
                    : 0}
                </p>
                {/* <a href="/totalMember" class="text-dark text-decoration-none">
                  Roylity Income
                </a> */}
                <p class="text-center text-white">Roylity Income</p>
              </div>
              <div class="col-3" onClick={() => navigate("/direct-income")}>
                <i class="bi bi-share"></i>
                <p>
                  {deshboard?.directincome
                    ? deshboard?.directincome?.toFixed(2)
                    : 0}
                </p>
                <p class="text-center text-white">Direct Income</p>
              </div>
              <div class="col-3" onClick={() => navigate("/rewardIncome")}>
                <i class="bi bi-share"></i>
                <p>
                  {deshboard?.rewardIncome
                    ? deshboard?.rewardIncome?.toFixed(2)
                    : 0}
                </p>
                <p class="text-center text-white">Reward Income</p>
              </div>
            </div>
          </div>
          <div class="team-card"  style={{ background: "linear-gradient(90deg, rgba(131,58,180,1) 0%, rgba(29,253,206,1) 50%, rgba(252,176,69,1) 100%)"}}>
            <h6 class="fw-bold bg-dark text-info p-2 ">
              <i class="bi bi-people icon"></i>My Team & My Orders
            </h6>
            <hr />
            <div class="row text-center">
              <div class="col-3" onClick={() => navigate("/direct-team")}>
                <i class="bi bi-people"></i>
                <p>{deshboard?.DirectTeam ? deshboard?.DirectTeam : 0}</p>
                <p class="text-center text-white">Direct Team</p>
              </div>
              <div class="col-3" onClick={() => navigate("/all-team")}>
                <i class="bi bi-award"></i>
                <p>{deshboard?.allTeam ? deshboard?.allTeam : 0}</p>
                <p class="text-center text-white">Total Team</p>
              </div>
              <div class="col-3" onClick={() => navigate("/my-order")}>
                <i class="bi bi-clipboard"></i>
                <p>{deshboard?.totalOrder}</p>
                {/* <a href="/totalMember" class="text-dark text-decoration-none">
                  Communtiy Enthusiasts
                </a> */}
                <p class="text-center text-white">Order</p>
              </div>
              <div class="col-3">
                <i class="bi bi-gear icon"></i>
                <p class="text-center">
                  <Link to="/settings" class="text-dark text-decoration-none">
                    Settings
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div style={{ height: "200px" }}></div>

          {/* <div class="orders-card">
            <h6 class="fw-bold">
              <i class="bi bi-cart icon"></i>My Orders{" "}
              <span class="float-end mt-1">Check Orders</span>
            </h6>
            <hr />
            <div class="row text-center">
              <div class="col-3" onClick={() => navigate("/my-order")}>
                <i class="bi bi-box"></i>
                <p>{deshboard?.totalOrder}</p>
                <p>Orders</p>
              </div>
              <div class="col-3">
                <i class="bi bi-hourglass-split"></i>
                <p>0</p>
                <p>Processing</p>
              </div>
              <div class="col-3">
                <i class="bi bi-basket"></i>
                <p>0</p>
                <p>Bought</p>
              </div>
              <div class="col-3">
                <i class="bi bi-cart-check"></i>
                <p>0</p>
                <p>Sold</p>
              </div>
            </div>
          </div>

          <div class="functions-card mb-5">
            <h6 class="fw-bold">
              <i class="bi bi-grid icon "></i>Common Functions
            </h6>
            <hr />
            <div class="row text-center">
              <div class="col-3">
                <i class="bi bi-book icon"></i>
                <p class="text-center">Tutorials</p>
              </div>
              <div class="col-3">
                <i class="bi bi-gear icon"></i>
                <p class="text-center">
                  <Link to="/settings" class="text-dark text-decoration-none">
                    Settings
                  </Link>
                </p>
              </div>

              <div class="col-3">
                <i class="bi bi-box-seam icon"></i>
                <p class="text-center">Mint</p>
              </div>
              <div class="col-3">
                <i class="bi bi-collection icon"></i>
                <p class="text-center">Collection</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
  );
}

export default My;
